module.exports = __webpack_public_path__ + "static/media/Public.2245cb48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Public.svg
// module id = 1143
// module chunks = 0